module.exports = __webpack_public_path__ + "static/media/team24.920de64b.jpeg";